import { jsx as _jsx } from "react/jsx-runtime";
import { ethers } from "ethers";
import { useContext, useEffect, useState } from "react";
import { WalletProviderContext } from "../walletprovider/WalletProvider";
const CONTRACT_ADDRESS = process.env.CONTRACT_ADDRESS || "";
const FUJI_RPC_URL = "https://api.avax-test.network/ext/bc/C/rpc";
const provider = new ethers.providers.JsonRpcProvider(FUJI_RPC_URL);
const ABI = [
    {
        inputs: [],
        name: "get",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "value",
                type: "string",
            },
        ],
        name: "set",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "hasData",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "getDataForAddress",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "string",
                name: "value",
                type: "string",
            },
        ],
        name: "setDataForAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "hasDataForAddress",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "key",
                type: "string",
            },
            {
                internalType: "string",
                name: "value",
                type: "string",
            },
        ],
        name: "setFeedbackData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAllFeedback",
        outputs: [
            {
                internalType: "string[]",
                name: "",
                type: "string[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "deleteAllFeedback",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
];
function SelfSignWallet() {
    const { selectedWallet, selectedAccount } = useContext(WalletProviderContext);
    const [dwinityStorage, setDwinityStorage] = useState(undefined);
    const [res, setRes] = useState(undefined);
    useEffect(() => {
        const asyncFunction = async () => {
            //console.log("provider", provider);
            const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, provider);
            //console.log("contract", contract);
            //console.log("selectedWallet", selectedWallet);
            //console.log("selectedAccount", selectedAccount);
            //await provider.send('eth_requestAccounts', []); // Error: processing response error (body="{\"jsonrpc\":\"2.0\",\"id\":44,\"error\":{\"code\":-32601,\"message\":\"the method eth_requestAccounts does not exist\"}}", error={"code":-32601}, requestBody="{\"method\":\"eth_requestAccounts\",\"params\":[],\"id\":44,\"jsonrpc\":\"2.0\"}", requestMethod="POST", url="https://api.avax-test.network/ext/bc/C/rpc", code=SERVER_ERROR, version=web/5.7.1)
            const signer = provider.getSigner(selectedAccount ?? undefined);
            //console.log("signer", signer);
            const contractWithSigner = contract.connect(signer);
            //console.log("contractWithSigner", contractWithSigner);
            //console.log("contract address", contractWithSigner.address);
            setDwinityStorage(contractWithSigner);
            await contractWithSigner?.setDataForAddress(selectedAccount, "efgh");
            setRes(await contractWithSigner?.getDataForAddress(selectedAccount));
            // Error: processing response error (body="{\"jsonrpc\":\"2.0\",\"id\":49,\"error\":{\"code\":-32601,\"message\":\"the method eth_sendTransaction is not available\"}}", error={"code":-32601}, requestBody="{\"method\":\"eth_sendTransaction\",\"params\":[{\"gas\":\"0x10612\",\"from\":\"0x5cf31665965fa15c89e12546a19733efc60e345b\",\"to\":\"0xe234fc648a854b98a07eea539fa932024e44ea2d\",\"data\":\"0x604ce9030000000000000000000000005cf31665965fa15c89e12546a19733efc60e345b000000000000000000000000000000000000000000000000000000000000004000000000000000000000000000000000000000000000000000000000000000046566676800000000000000000000000000000000000000000000000000000000\"}],\"id\":49,\"jsonrpc\":\"2.0\"}", requestMethod="POST", url="https://api.avax-test.network/ext/bc/C/rpc", code=SERVER_ERROR, version=web/5.7.1)
        };
        try {
            asyncFunction();
        }
        catch (error) {
            console.log(error);
        }
    }, [selectedAccount, selectedWallet]);
    return _jsx("div", { children: res });
}
export default SelfSignWallet;
